import React, { useState } from "react";

import { useTranslations, ConstantBasedPicker, baseApiUrl, ProgressOrError, apiHeaders } from "@openimis/fe-core";
import { useSelector } from "react-redux";
import {
  Box,
  Grid,
  Typography,
  Button,
  Divider,
  Input,
  FormControlLabel,
  Checkbox,
  Dialog,
  DialogContent,
  DialogTitle,
  DialogActions
} from "@material-ui/core";
import {
  STRATEGY_INSERT,
  STRATEGY_INSERT_UPDATE,
  STRATEGY_INSERT_UPDATE_DELETE,
  STRATEGY_UPDATE, RIGHT_UPLOAD_PAYROLLS
} from "../constants";
import Block from "../components/Block";

const PAYROLLCYCLE_STRATEGIES = [STRATEGY_INSERT, STRATEGY_UPDATE, STRATEGY_INSERT_UPDATE];

const PayrollCycleUploadPage = () => {
  const { formatMessage } = useTranslations("payroll.PayrollCyclePage");
  const [forms, setForms] = useState({});
  const rights = useSelector((state) => state.core?.user?.i_user?.rights ?? []);
  const [dialogState, setDialogState] = useState({});
  const [popupState, setPopupState] = useState({});

//   const hasRights = (rightsList) => rightsList.every((x) => rights.includes(x));

  const handleFieldChange = (formName, fieldName, value) => {
    setForms({
      ...forms,
      [formName]: {
        ...(forms[formName] ?? {}),
        [fieldName]: value,
      },
    });
  };

//get payroll uuid
  // const payroll_uuid = window.location.pathname.split("/")[4]
  const Payroll_URL = `${baseApiUrl}/payroll`
  const openPopup = (e, uploadType) => {
    setPopupState({
      open: true,
      openPayroll: uploadType === 'payrolls',
      anchorEl: e.currentTarget,
      error: null,
    });
  }
  
  const onPopupClose = (e) => {
    setPopupState({
      open: false,
      openPayroll: false, 
      anchorEl: null,
      error: null,
    });
  }

  const onDialogClose = (reason) => {
    if (reason === "escapeKeyDown" || reason === "backdropClick") {
      return;
    }
    setDialogState({ open: false });
  };

  const fetchPayrollCycleId = async (payrollcycle_id) => {
    console.log(payrollcycle_id)
    return payrollcycle_id
  }

  const onSubmit = async (values) => {
    setDialogState({
      open: true,
      isLoading: true,
      data: null,
      error: null,
    });
    setPopupState({
      open: false,
      anchorEl: null,
      error: null,
    });
    const formData = new FormData();
    formData.append("dry_run", Boolean(values.dryRun));
    formData.append("file", values.file);
    formData.append("strategy", values.strategy);

    const payrollcycleId = await fetchPayrollCycleId(window.location.pathname.split("/")[4]);

    formData.append("payrollcycle_id", payrollcycleId);


    try {
      const response = await fetch(`${Payroll_URL}/upload_payroll` ,{
        headers: apiHeaders,
        body: formData,
        method: "POST",
        credentials: "same-origin",
      });
      if (response.status >= 400) {
        throw new Error("Unknown error");
        console.log(response)
      }

      const payload = await response.json();
      setDialogState({
        open: true,
        isLoading: false,
        success: payload.success,
        data: payload.data,
        error: payload.error,
      });
    } catch (error) {
      console.error(error);
      setDialogState({
        open: true,
        isLoading: false,
        data: null,
        error: error?.message ?? formatMessage("An unknown error occurred. Please contact your administrator."),
      });
    }
  };
  console.log("Payrolls RENDERING")
  return (
    <>
      {dialogState?.open && (
        <Dialog open onClose={onDialogClose} fullWidth maxWidth="sm">
          <DialogTitle>{formatMessage("UploadDialog.title")}</DialogTitle>
          <DialogContent>
            <ProgressOrError progress={dialogState.isLoading} />
            {dialogState.error && <Box my={1}>{dialogState.error}</Box>}
            {!dialogState.isLoading && dialogState.data && (
              <>
                <Box my={1}>
                  <b>Status:</b>{" "}
                  {dialogState.success ? formatMessage("UploadDialog.success") : formatMessage("UploadDialog.failure")}
                </Box>
                {"sent" in dialogState.data && (
                  <Box my={1}>
                    <b>{formatMessage("UploadDialog.sent")}</b> {dialogState.data.sent}
                  </Box>
                )}
                {"created" in dialogState.data && (
                  <Box my={1}>
                    <b>{formatMessage("UploadDialog.created")}</b> {dialogState.data.created}
                  </Box>
                )}
                {"updated" in dialogState.data && (
                  <Box my={1}>
                    <b>{formatMessage("UploadDialog.updated")}</b> {dialogState.data.updated}
                  </Box>
                )}
                {"deleted" in dialogState.data && (
                  <Box my={1}>
                    <b>{formatMessage("UploadDialog.deleted")}</b> {dialogState.data.deleted}
                  </Box>
                )}
                {dialogState.data?.errors?.length > 0 && (
                  <Box my={1}>
                    <b>{formatMessage("UploadDialog.errors")}</b> {dialogState.data.errors.join(", ")}
                  </Box>
                )}
              </>
            )}
          </DialogContent>
          <DialogActions>
            <Button disabled={dialogState.isLoading} onClick={onDialogClose} variant="primary">
              {formatMessage("UploadDialog.okButton")}
            </Button>
          </DialogActions>
        </Dialog>
      )}
      <Box fullWidth m={4}>
        <Grid container spacing={2}>
          {/* {hasRights(RIGHT_UPLOAD_PAYROLLS) && ( */}
            <Grid item xs={4}>
              <Block title={formatMessage("payrollcycleBlockTitle")}>
                <Grid container spacing={2} direction="column">
                  <Grid item>
                    <Typography variant="h6">{formatMessage("payrollcycles.uploadLabel")}</Typography>
                  </Grid>
                  <Grid item>
                    <form noValidate>
                      <Grid container spacing={1} direction="column">
                        <Grid item>
                          <Input
                            onChange={(event) => handleFieldChange("payroll", "file", event.target.files[0])}
                            required
                            id="import-button"
                            inputProps={{
                              accept: ".csv, application/csv, text/csv, text/comma-separated-values, text/plain, application/octet-stream",
                            }}
                            type="file"
                          />
                        </Grid>
                        <Grid item>
                          <FormControlLabel
                            label={formatMessage("dryRunLabel")}
                            control={
                              <Checkbox
                                checked={forms.payroll?.dryRun}
                                onChange={(e) => handleFieldChange("payroll", "dryRun", e.target.checked)}
                              />
                            }
                          />
                        </Grid>
                        <Grid item>
                        <Button
                          variant="contained"
                          color="primary"
                          onClick={(e) => openPopup(e, 'payrolls')}
                          disabled={!(forms.payroll?.file)}
                        >
                          {formatMessage("uploadBtn")}
                        </Button>
                        {popupState?.open && popupState?.openPayroll && (
                        <Dialog open onClose={onPopupClose} fullWidth maxWidth="sm">
                            <DialogTitle>{formatMessage("UploadDialog.confirmPayrollCycle")}</DialogTitle>
                            <DialogActions>
                            <Button
                              variant="contained"
                              color="primary"
                              onClick={() => onSubmit(forms.payroll, "payroll")}
                              disabled={!(forms.payroll?.file)}
                            >
                              {formatMessage("uploadBtn")}
                            </Button>
                            <Button onClick={onPopupClose} variant="contained">
                              {formatMessage("cancelBtn")}
                            </Button>
                            </DialogActions>
                          </Dialog>)}
                        </Grid>
                      </Grid>
                    </form>
                  </Grid>
                </Grid>
              </Block>
            </Grid>
          
        </Grid>
      </Box>
    </>
  );
};

export default PayrollCycleUploadPage;